import { useLang } from "@/i18n";

export const LegalNotice = () => {
  const { lang, t } = useLang();
  if (lang === "de") return null;
  return (
    <div data-testid="legal-notice" className="mb-8 border-l-4 border-primary bg-primary/8 px-5 py-4 text-sm text-foreground/80">
      {t("legal.notice")}
    </div>
  );
};
